export class Projdocument {
    File: File;
    brochure: string;
    link: string;
}
